'use client';

import { useMemo } from 'react';
import { SLOT_TIME_ESTIMATE_MS } from '@velocity-exchange/sdk';
import { useCurrentSlot } from 'src/hooks/useCurrentSlot';
import { RelativeDateDisplay } from 'src/components/Tables/RelativeDateDisplay';
import { AccountOrder } from '../types';

interface TimeCellProps {
	order: AccountOrder;
	displayAsTimestamp: boolean;
}

export function TimeCell({ order, displayAsTimestamp }: TimeCellProps) {
	const currentSlot = useCurrentSlot();

	const orderTime = useMemo(() => {
		if (order.ts) return new Date(order.ts.toNumber() * 1000);
		const slotDiff = currentSlot - order.slot.toNumber();
		if (slotDiff < 0) return new Date();
		const estimatedMsAgo = slotDiff * SLOT_TIME_ESTIMATE_MS;
		return new Date(Date.now() - estimatedMsAgo);
	}, [order.slot, order.ts, currentSlot]);

	return (
		<RelativeDateDisplay
			date={orderTime}
			displayAsTimestamp={displayAsTimestamp}
		/>
	);
}
